module.exports = __webpack_public_path__ + "static/Canela-Deck-Bold-6e2da64b88f7e60cda1df63cb63cc8f2.ttf";